import * as React from "react";
import { connect } from "react-redux";
import { selectBalancingShopOfferGroupById } from "../../../balancingSelectors/selectBalancingPurchaseOfferGroups";
import { IdStyles } from "../../../less/IdStyles";
import { selectSelectedOffer } from "../../../selectors/selectShopInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { DialogWrapper } from "../../dialog/DialogWrapper";
import { TextLoca } from "../../generic/text/TextLoca";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
var _DialogShopGrowingOfferInfo = function (_a) {
    var selectedOffer = _a.selectedOffer, onClose = _a.onClose;
    if (selectedOffer === undefined) {
        return React.createElement(React.Fragment, null);
    }
    var _b = getGrowingFundLocas(selectedOffer.offerCharacteristicId), idLocaTitle = _b[0], idLocaDesc = _b[1];
    return (React.createElement(DialogWrapper, { titleLocaId: idLocaTitle, onClose: onClose, className: IdStyles.ModalBackgroundInfo },
        React.createElement("div", { className: "padding--large" },
            React.createElement(TextLoca, { id: idLocaDesc, className: IdStyles.TextNormal }))));
};
var getGrowingFundLocas = function (offerCharacteristicId) {
    var locaTitle = IdLoca.growingDollarPOs_helpText_title;
    var locaDesc = IdLoca.growingDollarPOs_helpText_desc;
    var balancingShopOfferGroup = selectBalancingShopOfferGroupById(offerCharacteristicId);
    if (balancingShopOfferGroup && balancingShopOfferGroup.locaKeyHelpText) {
        locaDesc = balancingShopOfferGroup.locaKeyHelpText;
        locaTitle = locaDesc.replace("desc", "title");
    }
    return [locaTitle, locaDesc];
};
var mapState = function (state) { return ({
    selectedOffer: selectSelectedOffer(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.ShopGrowingGoldOffer)); },
}); };
export var DialogShopGrowingOfferInfo = connect(mapState, mapDispatch)(_DialogShopGrowingOfferInfo);



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/DialogShopGrowingOfferInfo.tsx
// module id = 2903
// module chunks = 3